import React from "react";
import {
  apiCallPost,
  fixMedicineInsn,
  fixMedicineName,
  formatAge,
  niceDate,
  niceDateTime,
  renderQuantityNice,
  startLowerString,
} from "../util/util";
import {
  Button,
  ControlGroup,
  NonIdealState,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import "../RxV2.css";
import "../RxV21.css";

import _ from "lodash";
import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";
import { generateMasterVisitEntities } from "./RxV2Comp/masterVisitEntities";

import { planSectionDefaultStyle } from "./RxV21Cmp/ViewHelper";
import cogoToast from "cogo-toast";

function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouter;
}

class DischargeLowerOrder extends React.Component {
  state = { isLoading: true, isFailure: false, sxId: null, hasLoaded: false };
  componentDidMount() {
    let ss = this.props.params.sxId;
    this.setState({ sxId: ss });
    if (ss) {
      this.getDischarge(ss);
    } else {
      this.setState({ isLoading: false, isInvalid: true });
    }
  }
  getDischarge = async (ss) => {
    try {
      let res = await apiCallPost("/print/sxDischargeSummary", {
        sxId: ss,
      });
      const renderOptions = res.branchInfo.rxRenderOptions;
      let dischargeEntities = res.dischargeEntities;
      if ((renderOptions.supressIPDRxSection || []).length > 0) {
        const supressSet = new Set(renderOptions.supressIPDRxSection);
        dischargeEntities = dischargeEntities.filter((e) => {
          const key = `${e.sectionName}!${e.subsectionName}`;
          if (supressSet.has(key)) {
            return false;
          }
          return true;
        });
      }

      this.setState(
        { isLoading: false, hasLoaded: true, ...res, dischargeEntities },
        () => {
          document.title = `${this.state.patientName} - ${this.state.branchInfo.hospital_name}`;
        }
      );

      let sectionMaps = _.assign(
        {
          VISION: "Baseline Evaluation",
          HISTORY: "Context of Visit",
          EXAMINATION: "Examination",
          PLAN: "Plan",
          FILES: "Investigations & Procedures",
        },
        {}
      );
      let subSectionMaps = {};
      console.log({ shortcode: res.branchInfo.shortcode });
      const masterVisitEntities = generateMasterVisitEntities(
        res.branchInfo.shortcode || ""
      );
      for (let i = 0; i < masterVisitEntities.length; i++) {
        let section = masterVisitEntities[i];
        subSectionMaps[section.sectionName] = {};
        if (section.subsections) {
          for (let j = 0; j < section.subsections.length; j++) {
            let subSection = section.subsections[j];
            subSectionMaps[section.sectionName][subSection.subsectionName] =
              subSection.subsectionNiceName;
          }
        }
      }
      if (renderOptions.showGlassRxFooter) {
        renderOptions["footerHeight"] = "175px";
      }

      let entities = res.entities;
      if ((renderOptions.suppressOPDRxSection || []).length > 0) {
        const supressSet = new Set(renderOptions.suppressOPDRxSection);
        entities = entities.filter((e) => {
          const key = `${e.sectionName}!${e.subsectionName}`;
          if (supressSet.has(key)) {
            return false;
          }
          return true;
        });
      }

      this.setState({
        ...res,
        entities,
        isLoading: false,
        renderOptions,
        sectionMaps,
        subSectionMaps,
        masterVisitEntities,
      });
    } catch (err) {
      cogoToast.error("Failed to load discharge summary.");
      this.setState({ isLoading: false, isFailure: true });
    }
  };

  renderDx = () => {
    let diagnosis = this.state.dischargeEntities.filter(
      (currentItem) =>
        currentItem.sectionName === "EXAMINATION" &&
        (currentItem.subsectionName === "OBSERVATIONS" ||
          currentItem.subsectionName === "DIAGNOSIS")
    );
    if (!diagnosis.length) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
        }}
      >
        {this.renderHorizontalText("DIAGNOSIS")}
        {diagnosis.map((each) => {
          return (
            <div
              className="vision__workup__tags"
              style={{ borderLeft: "2px solid black", marginBottom: "10px" }}
            >
              <Tag minimal multiline className="font__x__small">
                {each.entityName}
              </Tag>
              <Tag minimal multiline className="font__x__small bg__none">
                {each.eye === "RE"
                  ? "Right Eye"
                  : each.eye === "LE"
                  ? "Left Eye"
                  : each.eye === "BE"
                  ? "Both Eyes"
                  : this.state.eye}
              </Tag>
            </div>
          );
        })}
      </div>
    );
  };
  renderSxDetails = () => {
    let procedurePerformed = this.state.lineItems
      .filter(
        (each) =>
          each.removedAfterBooking === false &&
          each.lineItemType !== "ANAESTHESIA" &&
          each.lineItemType !== "BED"
      )
      .map((each) => each.entityName)
      .reduce((acc, item, index, array) => {
        if (index === 0) return item;
        return `${acc} + ${item}`;
      }, "");

    procedurePerformed = procedurePerformed.endsWith(" + ")
      ? procedurePerformed.slice(0, -3)
      : procedurePerformed;

    console.log("procedurePerformed", procedurePerformed);

    return (
      <div
        style={{
          fontSize: "small",
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("CLINICAL DETAILS")}</>
        {/* <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            {this.state.dischargeEntities.filter(
              (currentItem) =>
                currentItem.sectionName === "EXAMINATION" &&
                (currentItem.subsectionName === "OBSERVATIONS" ||
                  currentItem.subsectionName === "DIAGNOSIS")
            ).length === 1
              ? "Diagnosis: "
              : "Diagnoses: "}
            <b>
              {" "}
              {this.state.dischargeEntities
                .filter(
                  (currentItem) =>
                    currentItem.sectionName === "EXAMINATION" &&
                    (currentItem.subsectionName === "OBSERVATIONS" ||
                      currentItem.subsectionName === "DIAGNOSIS")
                )
                .map((each) => {
                  return `${
                    each.laterality === "BILATERAL"
                      ? "Both Eyes"
                      : `${_.upperFirst(_.lowerCase(each.laterality))} Eye:`
                  } ${each.entityName}`;
                })
                .join(", ")}
            </b>
          </Tag>
        </div> */}

        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Procedure Performed: <b>{procedurePerformed}</b>
          </Tag>
        </div>

        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Operated Eye: <b>{this.state.eye}</b> | Anaesthesia:{" "}
            <b>{this.state.anaesthesiaType}</b>
          </Tag>
        </div>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Surgeon: <b>{this.state.surgeonName}</b> | Anaesthesist:{" "}
            <b>{this.state.anaesthetistName}</b>
          </Tag>
        </div>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            {this.state.dischargeEntities.filter(
              (currentItem) =>
                currentItem.sectionName === "EXAMINATION" &&
                (currentItem.subsectionName === "OBSERVATIONS" ||
                  currentItem.subsectionName === "DIAGNOSIS")
            ).length === 1
              ? "Diagnosis: "
              : "Diagnoses: "}
            <b>
              {" "}
              {this.state.dischargeEntities
                .filter(
                  (currentItem) =>
                    currentItem.sectionName === "EXAMINATION" &&
                    (currentItem.subsectionName === "OBSERVATIONS" ||
                      currentItem.subsectionName === "DIAGNOSIS")
                )
                .map((each) => {
                  return `${
                    each.laterality === "BILATERAL"
                      ? "Both Eyes"
                      : `${_.upperFirst(_.lowerCase(each.laterality))} Eye:`
                  } ${each.entityName}`;
                })
                .join(", ")}
            </b>
          </Tag>
          |
          <Tag minimal multiline className="font__x__small bg__none">
            Time of Admission:{" "}
            <b>
              {niceDateTime(
                _.filter(this.state.keyEvents, (k) => k.event === "Admission")
                  .length
                  ? _.filter(
                      this.state.keyEvents,
                      (k) => k.event === "Admission"
                    )[0].ts
                  : this.state.time
              )}
            </b>{" "}
          </Tag>
        </div>
        <div
          className="vision__workup__tags"
          style={{ marginBottom: "5px" }}
        ></div>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Surgery Starting Time:{" "}
            <b>
              {niceDateTime(
                _.filter(
                  this.state.keyEvents,
                  (k) => k.event === "Surgery Start"
                ).length
                  ? _.filter(
                      this.state.keyEvents,
                      (k) => k.event === "Surgery Start"
                    )[0].ts
                  : this.state.time
              )}
            </b>{" "}
          </Tag>
          |
          <Tag minimal multiline className="font__x__small bg__none">
            Time of Discharge:{" "}
            <b>
              {niceDateTime(
                _.filter(this.state.keyEvents, (k) => k.event === "Discharge")
                  .length
                  ? _.filter(
                      this.state.keyEvents,
                      (k) => k.event === "Discharge"
                    )[0].ts
                  : new Date()
              )}
            </b>
          </Tag>
        </div>
        {/* <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Discharge Notes: <b>{this.state.dischargeNotes}</b>
          </Tag>
        </div> */}
      </div>
    );
  };
  renderMedicines = () => {
    let meds = this.state.dischargeEntities.filter(
      (currentItem) =>
        currentItem.sectionName === "PLAN" &&
        currentItem.subsectionName === "MEDICATIONS"
    );
    if (!meds.length) {
      return null;
      //  (
      //   <div
      //     style={{
      //       display: "flex",
      //       flexDirection: "column",
      //       marginBottom: "10px",
      //     }}
      //   >
      //     <>{this.renderHorizontalText("MEDICINES")}</>
      //     <div className="font__x__small">
      //       No additional medicines prescribed at this time. Please adhere to
      //       instructions and advice given.
      //     </div>
      //   </div>
      // );
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("MEDICINES")}</>

        {meds.map((entity, index) => {
          let elements = [];
          let firstLine = [];
          firstLine.push(<>{index + 1}. </>);
          if (entity.laterality && entity.organ === "EYE") {
            if (entity.laterality === "LEFT") {
              firstLine.push(<b>LE - </b>);
            } else if (entity.laterality === "RIGHT") {
              firstLine.push(<b>RE - </b>);
            } else {
              firstLine.push(<b>BE - </b>);
            }
          }
          firstLine.push(
            <b style={planSectionDefaultStyle.bulletPointTitleStyle}>
              {fixMedicineName(entity.entityName)}
            </b>
          );
          if (entity.notes) {
            firstLine.push(<> ({entity.notes})</>);
          }
          if (entity.molecule) {
            elements.push(<> ({entity.molecule}) </>);
          }
          if (entity.instructions) {
            let text = <></>;
            if (entity.subsectionName === "MEDICATIONS") {
              let t = entity.instructions.split(";");
              t = t.map((entity) => entity.split(","));
              t = _.flatten(t);
              t = t.map((entity) => _.upperFirst(entity.trim()));
              text = (
                <>
                  {t.map((entity) => {
                    return <div>{fixMedicineInsn(entity)}</div>;
                  })}
                </>
              );
            } else {
              text = entity.instructions
                .split(",")
                .map((insn) => _.upperFirst(insn.trim()))
                .map((f) => <div>{f}</div>);
            }
            elements.push(
              <div style={planSectionDefaultStyle.instructionStyle}>{text}</div>
            );
          }

          if (entity.anaesthesia) {
            let niceStrings = {
              TOPICAL_ANAESTHESIA: "TA",
              LOCAL_ANAESTHESIA: "LA",
              REGIONAL_ANAESTHESIA: "RA",
              GENERAL_ANAESTHESIA: "GA",
            };
            elements.push(<>↓: {niceStrings[entity.anaesthesia]} </>);
          }
          if (entity.sxLinkedInvestigations) {
            let niceStrings = {
              BIOMETRY_OCT_SPECULAR: "Biometry, OCT and Specular",
              BIOMETRY_OCT_SYRINGING_SPECULAR:
                "Biometry, OCT, Syringing and Specular",
              OCT_DFP: "OCT and DFP",
              "ECG_X-RAY_PPBS": "ECG, X-Ray and PPBS",
            };
            elements.push(" | Pre-Surgery Investigations: ");
            elements.push(niceStrings[entity.sxLinkedInvestigations]);
            if (entity.notes) {
              elements.push(` (${entity.notes})`);
            }
          }

          return (
            <div style={planSectionDefaultStyle.subSectionBulletPoint}>
              <div>
                {firstLine.map((entity) => {
                  return <>{entity}</>;
                })}
              </div>

              {elements.map((entity) => (
                <div>{entity}</div>
              ))}
            </div>
          );
        })}
      </div>
    );
  };
  renderSurgicalNotes = () => {
    return null;
    let notes = this.state.dischargeEntities.filter(
      (currentItem) =>
        currentItem.subsectionName === "SURGERY" &&
        currentItem.sectionName === "NOTES"
    );
    if (!notes.length) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "10px",
          }}
        >
          <>{this.renderHorizontalText("SURGICAL NOTES")}</>
          <div className="font__x__small">
            No additional surgical notes available at this time.
          </div>
        </div>
      );
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("SURGICAL NOTES")}</>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag
            minimal
            multiline
            className="font__x__small bg__none"
            style={{ lineHeight: "20px" }}
          >
            {notes[0]?.surgicalNotes}
          </Tag>
        </div>
      </div>
    );
  };

  renderDischargeNotes = () => {
    let dischargeNotes = this.state.dischargeFreeText;
    if (!dischargeNotes) {
      return null;
      //  (
      //   <div
      //     style={{
      //       display: "flex",
      //       flexDirection: "column",
      //       marginBottom: "10px",
      //     }}
      //   >
      //     <>{this.renderHorizontalText("DISCHARGE NOTES")}</>
      //     <div className="font__x__small">
      //       No additional discharge notes available at this time.
      //     </div>
      //   </div>
      // );
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("DISCHARGE NOTES")}</>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            <span dangerouslySetInnerHTML={{ __html: dischargeNotes }} />
          </Tag>
        </div>
      </div>
    );
  };
  renderAdvice = () => {
    let adv = this.state.dischargeEntities.filter(
      (currentItem) =>
        currentItem.sectionName === "PLAN" &&
        currentItem.subsectionName === "ADVICE"
    );

    if (!adv.length) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("ADVICE")}</>

        {adv.map((each) => {
          return (
            <div
              className="vision__workup__tags"
              style={{ marginBottom: "5px" }}
            >
              <Tag minimal multiline className="font__x__small bg__none">
                {`• ${each.entityName}`}
              </Tag>
              <Tag minimal multiline className="font__x__small bg__none">
                {each.instructions}
              </Tag>
            </div>
          );
        })}
      </div>
    );
  };
  renderFU = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("FOLLOW UP")}</>

        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            Follow Up Appointment: {this.state.followUpAppt}
          </Tag>
        </div>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            In case you experience pain, swelling, redness, sudden drop in
            vision, injury to the operated eye or any other discomfort, please
            contact us immediately, or visit the nearest branch of the hospital.
          </Tag>
        </div>
        <div className="vision__workup__tags" style={{ marginBottom: "5px" }}>
          <Tag minimal multiline className="font__x__small bg__none">
            {this.state.postSxContact} You can also call us on{" "}
            {this.state.branchInfo.ClinicPh}{" "}
            {this.state.affliation === "5fd1ccd11c831ff79460601e"
              ? "or on 03366360000 between 8 am to 5 pm"
              : null}{" "}
            to reach the hospital help desk.
          </Tag>
        </div>
      </div>
    );
  };
  renderDoc = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          marginLeft: "10px",
          textAlign: "right",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ fontSize: "large" }}>
            <b>{this.state.resourceInfo.name}</b>
          </div>
          <div className="font__small">
            <b>{this.state.resourceInfo.qualifications}</b>
          </div>
          <div className="font__small">
            Registration: <b>{this.state.resourceInfo.mrNumber}</b>
          </div>
        </div>
      </div>
    );
  };
  renderItems = () => {
    if (!this.state.consumedItems) {
      return null;
    }
    if (!this.state.consumedItems.length) {
      return null;
    }
    return (
      <div style={{ marginBottom: "50px" }}>
        <div>
          {this.renderHorizontalText("ITEMS IMPLANTED/USED IN SURGERY")}
        </div>
        <table
          className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped"
          style={{ marginLeft: "auto", marginRight: "auto", width: "90vw" }}
        >
          <thead>
            <tr>
              <th>#</th> <th>Item</th>
              <th>Batch/Serial</th>
              <th>Expiry Date</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>{this.renderEachItem()}</tbody>
        </table>
      </div>
    );
  };

  renderBottomHospitalInfoBarNew = () => {
    return [
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          fontSize: "medium",
          marginBottom: "5px",
          borderBottom: "1px solid grey",
        }}
      >
        <b>{this.state.branchInfo.hospital_contact[0]}</b>
      </div>,

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "start",
          }}
        >
          <div>
            <img
              alt="Client Logo"
              src={this.state.branchInfo.logoUrl}
              height="80px"
              width="auto"
            />
          </div>
          <div
            style={{
              marginLeft: "10px",
              marginRight: "10px",
              textTransform: "uppercase",
              letterSpacing: "1mm",
              fontSize: "small",
              textAlign: "left",
              maxWidth: "125px",
            }}
          >
            {this.state.branchInfo.sesiNABH ? (
              <img
                src={this.state.branchInfo.sesiNABH}
                alt="NABH Certified"
                style={{
                  height: "70px",
                }}
              />
            ) : (
              <div>{this.state.branchInfo.hospital_name}</div>
            )}
          </div>
          <div>
            Address:
            <br />
            {this.state.branchInfo.hospital_contact[1]}
            <br />
            {this.state.branchInfo.hospital_contact[2]}
            <br />
            {this.state.branchInfo.hospital_contact[3]}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
          }}
        >
          <div
            style={{
              textAlign: "right",
            }}
          >
            {this.state.branchInfo.ClinicPh ? (
              <b
                style={{
                  fontSize: "medium",
                }}
              >
                Hospital: {this.state.branchInfo.ClinicPh}
                <br />
              </b>
            ) : null}
            {this.state.branchInfo.EmergencyPh ? (
              <div>
                Office: {this.state.branchInfo.EmergencyPh}
                <br />
              </div>
            ) : null}
            {!this.state.renderOptions.suppressEyeBankPh &&
            this.state.branchInfo.EyeBankPh ? (
              <>
                Eye Bank: {this.state.branchInfo.EyeBankPh}
                <br />
              </>
            ) : null}
            {!this.state.renderOptions.suppressInsurancePh &&
            this.state.branchInfo.InsurancePh ? (
              <>
                Insurance: {this.state.branchInfo.InsurancePh}
                <br />
              </>
            ) : null}
            {this.state.branchInfo.email ? (
              <>
                {this.state.branchInfo.email}
                <br />
              </>
            ) : null}
            {this.state.branchInfo.website ? (
              <>
                {this.state.branchInfo.website}
                <br />
              </>
            ) : null}
          </div>
          <div
            style={{
              marginLeft: "10px",
            }}
          >
            <QRCode
              size={70}
              value={`https://print.newchart.care/rx2/${this.props.params.visitId}`}
              level="H"
            />
          </div>
        </div>
      </div>,

      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {this.state.branchInfo.sesiDELT ? (
          <b style={{ color: "red" }}>{this.state.branchInfo.sesiDELT}</b>
        ) : (
          ""
        )}
      </div>,
    ];
  };

  renderEachItem = () => {
    if (!this.state.consumedItems) {
      return null;
    }
    if (!this.state.consumedItems.length) {
      return null;
    }
    return this.state.consumedItems.map((each, index) => {
      return (
        <tr>
          <td>{index + 1}</td>
          <td>{each.itemName}</td>
          <td>{each.inventoryDetails.serialNumber}</td>
          <td>{niceDate(each.inventoryDetails.expiresOn)}</td>
          <td>
            {renderQuantityNice(
              each.inventoryDetails.quantity,
              each.inventoryDetails.subunitOfConsumption,
              each.itemUnitName,
              each.itemSubunitName
            )}
          </td>
        </tr>
      );
    });
  };

  renderHorizontalText = (text, isProminent = false) => {
    return (
      <div
        style={{
          backgroundColor: "#E6E7E7",
          marginBottom: "10px",
          fontSize: "110%",
          letterSpacing: "1mm",

          border: `${isProminent ? "1px solid #b8a09e" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };

  renderVisitSummaryTopBar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "100%",
          flexWrap: "wrap",
          borderBottom: "1px solid grey",
        }}
      >
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div
            style={{
              letterSpacing: "1mm",
              borderRight: "2px solid #000",
              fontSize: "medium",
              textAlign: "right",
              paddingLeft: "5px",
              paddingRight: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {this.state.affliation === "64fdc342d6098c0c077dee32" ? (
              <>
                DISCHARGE <br /> CERTIFICATE
              </>
            ) : (
              <>
                DISCHARGE <br /> SUMMARY
              </>
            )}
          </div>
          <div
            style={{
              fontSize: "smaller",
            }}
          >
            <div
              style={{
                paddingLeft: "10px",
                textTransform: "uppercase",
              }}
            >
              <b>{this.state.patientName}</b>
            </div>
            <div
              style={{
                paddingLeft: "10px",
              }}
            >
              {this.state.patientSex} | {formatAge(this.state.patientDob)}
            </div>

            <div
              style={{
                marginLeft: "10px",
                paddingLeft: "2px",
                paddingRight: "2px",
                border: "1px solid black",
                width: "fit-content",
                fontSize: "large",
                backgroundColor: "#E6E7E7",
              }}
            >
              <b>{this.state.patientGenericPid}</b>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "smaller",
            flexDirection: "column",
            textAlign: "right",
          }}
        >
          <div>{this.state.patientAddress}</div>

          <div>Phone: {this.state.patientPhone}</div>

          <div className="pres-no__print">
            <ControlGroup>
              <Button
                icon="print"
                text="Print"
                onClick={() => {
                  window.print();
                }}
                fill
              />
            </ControlGroup>
          </div>
        </div>
      </div>
    );
  };
  renderPageHeader = () => {
    return this.state.affliation === "64fdc342d6098c0c077dee32" ||
      this.state.affliation === "5fd1ccd11c831ff79460601e" ? (
      <div style={{ marginBottom: "8px", marginTop: "8px" }}>
        {this.renderVisitSummaryTopBar()}
      </div>
    ) : (
      <div className="rx21_page_header">{this.renderVisitSummaryTopBar()}</div>
    );
  };
  renderPageFooter = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          position: "fixed",
          bottom: 0,
          width: "100%",
          borderTop: "0px",
          height: this.state.renderOptions.footerHeight,
          backgroundColor: "white",
        }}
      >
        {this.state.renderOptions.renderDocPosition === "FOOTER" ? (
          <div style={{ alignSelf: "flex-end", marginRight: "10px" }}>
            {this.renderDoc()}
          </div>
        ) : null}

        {this.renderBottomHospitalInfoBarNew()}
      </div>
    );
  };
  renderContentTable = () => {
    console.log("here", this.state.affliation);
    return (
      <table>
        <thead>
          <tr>
            <td>
              <div className="rx21_page_header_space"></div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div>
                {this.state.affliation === "64fdc342d6098c0c077dee32" ? (
                  <div>
                    {/* <div style={{ display: "flex", justifyContent: "center" }}>
                      {this.state.affliation === "64fdc342d6098c0c077dee32" ? (
                        <h2>DISCHARGE CERTIFICATE</h2>
                      ) : null}
                    </div> */}
                    {this.renderPageHeader()}
                    {this.renderSxDetails()}
                    {this.renderItems()}
                    {this.renderMedicines()}
                    {this.renderSurgicalNotes()}
                    {this.renderDischargeNotes()}
                    {this.renderAdvice()}
                    {this.renderFU()}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "20px",
                        marginTop: "30px",
                      }}
                    >
                      <div>Patient / Relative’s Signature </div>

                      <div></div>
                    </div>
                    {this.renderDoc()}
                  </div>
                ) : this.state.affliation === "5fd1ccd11c831ff79460601e" ? (
                  <div>
                    {this.renderPageHeader()}
                    {this.renderSxDetails()}
                    {this.renderMedicines()}
                    {this.renderSurgicalNotes()}
                    {this.renderDischargeNotes()}
                    {this.renderAdvice()}
                    {this.renderFU()}
                    {this.renderItems()}
                  </div>
                ) : (
                  <div>
                    {this.renderSxDetails()}
                    {this.renderMedicines()}
                    {this.renderSurgicalNotes()}
                    {this.renderDischargeNotes()}
                    {this.renderAdvice()}
                    {this.renderFU()}
                    {this.renderItems()}
                  </div>
                )}

                {/* {this.renderDoc()} */}
              </div>
            </td>
          </tr>
        </tbody>
        {this.state.affliation === "64fdc342d6098c0c077dee32" ? null : (
          <tfoot>
            <tr>
              <td>
                <div className="rx21_page_footer_space"></div>
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div
          style={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div>
      );
    }
    if (this.state.isError) {
      return (
        <div
          style={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    return (
      <div>
        <div style={{ padding: "3px" }}>
          <style type="text/css" media="print">
            {" @page { size: A4 portrait !important; margin: 5mm !important;"}
          </style>

          {this.state.affliation === "64fdc342d6098c0c077dee32" ? (
            <div style={{ marginTop: "65px" }}></div>
          ) : this.state.affliation === "5fd1ccd11c831ff79460601e" ? (
            <div style={{ marginTop: "47px" }}>
              {/* {this.renderPageHeader()} */}
              {this.renderPageFooter()}
            </div>
          ) : (
            <div>
              {this.renderPageHeader()}
              {this.renderPageFooter()}
            </div>
          )}

          {this.renderContentTable()}
        </div>
      </div>
    );
  }
}

const DischargeV2 = withRouter(DischargeLowerOrder);
export default DischargeV2;
